export default __webpack_public_path__ + "static/media/pic4.c72422c8.jpg";